import React, { useState, useRef } from "react";
import { createResult } from "../../graphQLModel/mutations";
import http from "../../services/httpService";
import gql from "graphql-tag";
import authService from "../../services/authService";
import assessmentLocalStoregService from "../../services/assessmentLocalStoreg";

export default function Survey({
  hideLoadingValue,
  showLoadingValue,
  history,
  setBackAddress
}) {
  const [step1, setStep1] = useState(null);
  const [step2, setStep2] = useState(null);
  const [step3, setStep3] = useState(null);
  const [step4, setStep4] = useState(null);
  const [step5, setStep5] = useState(null);

  const scrollToRef = (ref) => {
    setTimeout(() => ref.current.scrollIntoView({ behavior: "smooth" }), 100);
  };
  const step2Section = useRef(null);
  const step3Section = useRef(null);
  const step4Section = useRef(null);
  const step5Section = useRef(null);

  const handlerStep1Yes = () => {
    setStep1(true);
    setStep2(null);
    setStep3(null);
    setStep4(null);
    setStep5(null);
  };

  const handlerStep1No = () => {
    setStep1(false);
    setStep2(null);
    setStep3(null);
    setStep4(null);
    setStep5(null);
    scrollToRef(step2Section);
  };

  // step2

  const handlerStep2Yes = () => {
    setStep2(true);
    setStep3(null);
    setStep4(null);
    setStep5(null);
  };

  const handlerStep2No = () => {
    setStep2(false);
    setStep3(null);
    setStep4(null);
    setStep5(null);
    scrollToRef(step3Section);
  };

  // step3

  const handlerStep3Yes = () => {
    setStep3(true);
    setStep4(null);
    setStep5(null);
    scrollToRef(step4Section);
  };

  const handlerStep3No = () => {
    setStep3(false);
    setStep4(null);
    setStep5(null);
    scrollToRef(step4Section);
  };

  // step4

  const handlerStep4Yes = () => {
    setStep4(true);
    setStep5(null);
    scrollToRef(step5Section);
  };

  const handlerStep4No = () => {
    setStep4(false);
    setStep5(null);
    scrollToRef(step5Section);
  };

  // step5

  const handlerStep5Yes = () => {
    setStep5(true);
  };

  const handlerStep5No = () => {
    setStep5(false);
  };

  const handlerSubmit = async () => {
    try {
      showLoadingValue();
      const totalResult =
        (+step1).toString() +
        (+step2).toString() +
        (+step3).toString() +
        (+step4).toString() +
        (+step5).toString();
      let createId = "00000000-0000-0000-0000-000000000000";
      if (await authService.isValid()) {
        // const result = await http.mutate({
        //   mutation: gql(createResult),
        //   variables: {
        //     input: {
        //       device: navigator.userAgent,
        //       org: "hamzeh",
        //       result: totalResult,
        //     },
        //   },
        // });

        // if (result && result.data && result.data.createResult && result.data.createResult.id){
        assessmentLocalStoregService.setAnswer({
          // id: result.data.createResult.id,
          date: new Date(),
          answer: totalResult,
          username: authService.getUserInfoNormal(),
        });
        // createId = result.data.createResult.id;
        // }
      }
      history.push(`/survey/result/${parseInt(totalResult, 2)}`);
      hideLoadingValue();
    } catch (error) {
      console.log("error", error);
      hideLoadingValue();
    }
  };

  return (
    <>
      <div className="app-pages">
        <i
          style={{ fontSize: "32px", marginLeft: "18px", marginBottom: "15px" }}
          class="material-icons dp48"
          onClick={() => {
            history.push("/");
            return false;
          }}
        >
          arrow_back
        </i>
        <div className="had-container">
          <div className="survey-section">
            <p className="survey-survey-title">
              Are you experiencing any of the following:
            </p>
            <p className="survey-subtitle">
              Severe difficulty breathing (e.g. struggling to breathe or
              speaking in single words)
            </p>
            <p className="survey-subtitle">Severe chest pain</p>
            <p className="survey-subtitle">Having a very hard time waking up</p>
            <p className="survey-subtitle">Feeling confused</p>
            <p className="survey-subtitle">Losing consciousness</p>
            <div className="row" style={{ paddingTop: "50px" }}>
              <button
                className={
                  "waves-effect waves-light btn-large " +
                  (step1 === false ? "select-btn" : " defult-btn")
                }
                onClick={handlerStep1No}
              >
                NO
              </button>
              {"‌‌         ‌‌"}
              <button
                className={
                  "waves-effect waves-light btn-large margin-left-20 " +
                  (step1 === true ? "select-btn" : " defult-btn")
                }
                onClick={handlerStep1Yes}
              >
                YES
              </button>
            </div>
          </div>

          {step1 === false && (
            <div className="survey-section" ref={step2Section}>
              <p className="survey-survey-title">
                Are you experiencing any of the following:
              </p>
              <p className="survey-subtitle">
                Mild to moderate shortness of breath
              </p>
              <p className="survey-subtitle">
                Inability to lie down because of difficulty breathing
              </p>
              <p className="survey-subtitle">
                Chronic health conditions that you are having difficulty
                managing because of difficulty breathing
              </p>
              <div className="row" style={{ paddingTop: "50px" }}>
                <button
                  className={
                    "waves-effect waves-light btn-large " +
                    (step2 === false ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep2No}
                >
                  NO
                </button>
                {"‌‌         ‌‌"}
                <button
                  className={
                    "waves-effect waves-light btn-large margin-left-20 " +
                    (step2 === true ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep2Yes}
                >
                  YES
                </button>
              </div>
            </div>
          )}

          {step2 === false && (
            <div className="survey-section" ref={step3Section}>
              <p className="survey-survey-title">
                Are you experiencing cold, flu or COVID-19-like symptoms, even
                mild ones?
              </p>
              <p className="survey-subtitle">
                Symptoms include: Fever*, chills, cough or worsening of chronic
                cough, shortness of breath, sore throat, runny nose, loss of
                sense of smell or taste, headache, fatigue, diarrhea, loss of
                appetite, nausea and vomiting, muscle aches.
              </p>
              <p className="survey-subtitle">
                While less common, symptoms can also include: stuffy nose,
                conjunctivitis (pink eye), dizziness, confusion, abdominal pain,
                skin rashes or discoloration of fingers or toes.
              </p>
              <p className="survey-subtitle">
                Fever: Average normal body temperature taken orally is about
                37°C.
              </p>
              <div
                className="row"
                style={{ paddingTop: "50px" }}
                ref={step4Section}
              >
                <button
                  className={
                    "waves-effect waves-light btn-large " +
                    (step3 === false ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep3No}
                >
                  NO
                </button>
                {"‌‌         ‌‌"}
                <button
                  className={
                    "waves-effect waves-light btn-large margin-left-20 " +
                    (step3 === true ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep3Yes}
                >
                  YES
                </button>
              </div>
            </div>
          )}

          {(step3 === false || step3 === true) && (
            <div className="survey-section" ref={step4Section}>
              <p className="survey-survey-title">
                Have you travelled to other countries within the last 14 days?
                Travel includes passing through an airport
              </p>
              <div className="row" style={{ paddingTop: "50px" }}>
                <button
                  className={
                    "waves-effect waves-light btn-large " +
                    (step4 === false ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep4No}
                >
                  NO
                </button>
                {"‌‌         ‌‌"}
                <button
                  className={
                    "waves-effect waves-light btn-large margin-left-20 " +
                    (step4 === true ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep4Yes}
                >
                  YES
                </button>
              </div>
            </div>
          )}

          {(step4 === false || step4 === true) && (
            <div className="survey-section" ref={step5Section}>
              <p className="survey-survey-title">
                Did you provide care or have close contact with a person with
                confirmed COVID-19?
              </p>
              <div className="row" style={{ paddingTop: "50px" }}>
                <button
                  className={
                    "waves-effect waves-light btn-large " +
                    (step5 === false ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep5No}
                >
                  NO
                </button>
                {"‌‌         ‌‌"}
                <button
                  className={
                    "waves-effect waves-light btn-large margin-left-20 " +
                    (step5 === true ? "select-btn" : " defult-btn")
                  }
                  onClick={handlerStep5Yes}
                >
                  YES
                </button>
              </div>
            </div>
          )}

          <div className="row center" style={{ paddingTop: "70px" }}>
            <button
              onClick={handlerSubmit}
              className="waves-effect waves-light submit-button"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
